import { Component, OnInit } from '@angular/core';
import { CaseComponent } from '@app/modules/case/components/case-base/case.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseService } from '@app/core/services/case.service';

@Component({
    templateUrl: './case-detailed-results.component.html',
    styleUrls: ['./case-detailed-results.component.scss']
})
export class CaseDetailedResultsComponent extends CaseComponent
                                          implements OnInit {

    constructor(protected componentServiceBundle: ComponentServiceBundle, protected caseService: CaseService) {
        super(componentServiceBundle, caseService);
        this._idPrefix = 'case_detailed_results.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }
}
